var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      multiple: _vm.multiple,
      filterable: "",
      placeholder: "请选择",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.someSelect();
      }
    },
    model: {
      value: _vm.label,
      callback: function callback($$v) {
        _vm.label = $$v;
      },
      expression: "label"
    }
  }, _vm._l(_vm.taskOptions, function (item) {
    return _c("el-option", {
      key: item.gameplayTypeId,
      attrs: {
        label: item.gameplayTypeName + " (" + item.gameplayTypeId + ")",
        value: item.gameplayTypeId
      }
    });
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };